import { createAction, props } from '@ngrx/store';
import type { DataLayerBaseEvent, DataLayerEventTypes } from '../services/google-analytics/google-analytics.model';

export const trackEventWithUserUid = createAction(
  '[Google Analytics] Track Event With User ID',
  props<{ payload: DataLayerBaseEvent<DataLayerEventTypes | string> }>()
); 